import { CAMPAIGN_STATUS_LABEL_KEY, CAMPAIGN_STATUS_TONE } from '@constants/social-posts';
import StatusBadge from './StatusBadge';

// Campaign lifecycle phase only; per-post outcomes are shown separately by PostOutcomeSummary.
const CampaignStatusChip = ({ status, t }) => (
    <StatusBadge
        status={status}
        toneByStatus={CAMPAIGN_STATUS_TONE}
        labelKeyByStatus={CAMPAIGN_STATUS_LABEL_KEY}
        t={t}
    />
);

export default CampaignStatusChip;
